import React from 'react';
import NavigationBar from '../../../components/NavigationBar/NavigationBar';
import {
  formatMoneyEuro,
  isLocalizeAdded,
  LocalizePropType,
} from 'getaway-data-layer';
import './DepositView.less';
import BrandButton from '../../../components/BrandButton/BrandButton';
import { GA_TITLES, isDashboardScreen } from '../../../../utils';
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import TariffItem from '../../../components/TariffItem/TariffItem';

type props = {
  localize: LocalizePropType;
  onClose: () => void;
  onSubmit: () => void;
  amount: number;
  paymentLink?: string;
};

const DepositView = ({
  localize,
  amount,
  onSubmit,
  onClose,
  paymentLink,
}: props) => {
  return (
    <div className="screen-container">
      <NavigationBar
        TitleTestId="DepositView-title"
        title={localize(`deposit.title`)}
        description={localize(`deposit.desc`)}
        showHelp
        onClose={onClose}
        showArrowBack={isDashboardScreen()}
      />
      <div
        className={
          isLocalizeAdded(localize, 'deposit.faq')
            ? 'screen-body-faq'
            : 'screen-body'
        }
      >
        <div
          className={
            isLocalizeAdded(localize, 'deposit.faq')
              ? 'screen-body-content-faq'
              : 'screen-body-content'
          }
        >
          <TariffItem
            tariffTestId="TariffView-contanier"
            firstItem
            lastItem
            localize={localize}
            title={localize(`deposit.card.title`)}
            price={localize(`deposit.card.price`, formatMoneyEuro(amount))}
            description={localize(`deposit.card.desc.md`)}
            selected
            onClick={() => {}}
          />

          <div>
            <img
              className="deposit-secure-image"
              src="/images/trustLogos.png"
              alt="add-sepa-logo"
            />
          </div>

          <div className="deposit-bottom-sheet">
            <div className="deposit-payments">
              <img
                src="/images/payment-methods-deposit.png"
                alt="payment-methods"
                style={{ height: 20 }}
              />
              <div style={{ fontWeight: 600, color: 'black' }}>
                {formatMoneyEuro(amount)}
              </div>
            </div>

            <BrandButton
              id={GA_TITLES.BOOKING.CONFIRM}
              title={localize('deposit.cta')}
              onClick={onSubmit}
              containerStyles={
                paymentLink
                  ? {
                      display: 'inline-block',
                      position: 'relative',
                      left: 'unset',
                      right: 'unset',
                      bottom: 'unset',
                      width: '100%',
                      textDecoration: 'none',
                      textAlign: 'center',
                    }
                  : {
                      position: 'relative',
                      left: 'unset',
                      right: 'unset',
                      bottom: 'unset',
                      width: '100%',
                    }
              }
              url={paymentLink}
            />

            <div className="deposit-secure-footnote">
              <img
                src="/images/lock.png"
                className="signup-footnote-secure-icon"
                alt="alt"
              />
              <div className="deposit-secure-text">
                {localize('deposit.footnote.secure.text')}
              </div>
            </div>
          </div>
        </div>
        {isLocalizeAdded(localize, 'deposit.faq') && (
          <div className="faq">
            <Markdown rehypePlugins={[rehypeRaw]}>
              {localize('deposit.faq')}
            </Markdown>
          </div>
        )}
        <div className="screen-vertical-space" style={{ height: 170 }} />
      </div>
    </div>
  );
};

export default DepositView;
